// BaseModel
import baseModel from 'redux/baseModel'

export default {
  ...baseModel,
}
